export const USER_ID_KEY = 'currentUid';

const HEALTH_RECORD_PREFIX = 'healthRecords_';
const WELLNESS_GOALS_PREFIX = 'wellnessGoals_';

// Remove all keys that are scoped to a particular user profile
export function clearPerUserCache() {
  Object.keys(localStorage).forEach(key => {
    if (key.startsWith(HEALTH_RECORD_PREFIX) || 
        key.startsWith(WELLNESS_GOALS_PREFIX)) {
      localStorage.removeItem(key);
    }
  });
}

export function logoutCleanup() {
  clearPerUserCache();
  localStorage.removeItem(USER_ID_KEY);
} 